import { StepCounter } from "./step-counter";
import { GpsTracker } from "./gps-tracker";
import { StepLengthUtil } from "./step-length-util";

export class StepController {

    private sc: StepCounter;

    constructor() {
        this.sc = new StepCounter();
    }

    newStep() {
        this.sc.increaseStepCount();
        this.sc.setTotalDistance(this.sc.getTotalStepCount() * StepLengthUtil.AVERAGE_STEP);

        this.calculateMyStep();

        if (!GpsTracker.isGPS) {
            this.sc.setEndStep(this.sc.getTotalStepCount());
            this.sc.setPartStepCount(this.sc.getEndStep() - this.sc.getStartStep());
            this.sc.setPartDistance(this.sc.getPartStepCount() * this.sc.getMyStep());
            GpsTracker.sumDistance += this.sc.getMyStep();
        } else {
            this.sc.setStartStep(this.sc.getTotalStepCount());
            this.sc.setPartStepCount(0);
            this.sc.setPartDistance(0);
        }

        this.calculateMyStep();

        console.log('this.sc.getTotalDistance: ' + this.sc.getTotalDistance());
        console.log('this.sc.getTotalCount: ' + this.sc.getTotalStepCount());
        if (this.sc.getTotalDistance() > GpsTracker.sumDistance) GpsTracker.sumDistance = this.sc.getTotalDistance();
    }

    clear() {
        this.sc.setPartDistance(0);
        this.sc.setTotalDistance(0);
        this.sc.setStartStep(0);
        this.sc.setEndStep(0);
        this.sc.setPartStepCount(0);
        this.sc.setTotalStepCount(0);
    }

    calculateMyStep() {
        if (!GpsTracker.isBackground && GpsTracker.sumDistance < 200) {

            this.sc.setMyStep(StepLengthUtil.calculateMyStep(GpsTracker.sumDistance, this.sc.getTotalStepCount()));
        }
    }

    getMyStepLength() {
        return this.sc.getMyStep();
    }

    getGpsStatus() {
        return GpsTracker.isGPS;
    }

    getTotalStepCount() {
        return this.sc.getTotalStepCount();
    }

    getPartStepCount() {
        return this.sc.getPartStepCount();
    }

    getTotalDistance() {
        return this.sc.getTotalDistance();
    }

    getPartDistance() {
        return this.sc.getPartDistance();
    }
}


// WEBPACK FOOTER //
// /src/tracker/step-controller.ts